import { Card } from '@loadsmart/loadsmart-ui'
import { Text, Layout } from '@loadsmart/miranda-react'

import { Icon } from 'core/ui/components/icon/Icon'

import Divider from './Divider'

type LoadSetupProps = {
  children: JSX.Element
}

export default function LoadSetup({ children }: LoadSetupProps) {
  return (
    <Card>
      <Card.Body>
        <Layout.Stack gap="spacing-2">
          <Layout.Group align="center" gap="spacing-2">
            <Icon name="board" height="16" />
            <Text variant="heading-sm-bold">Set up your load for a better experience</Text>
          </Layout.Group>
          <Divider />
          {children}
        </Layout.Stack>
      </Card.Body>
    </Card>
  )
}
